import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _styled from '@emotion/styled/base';
import { useState, useRef, useEffect } from 'react';
import { Checkbox } from './checkbox.js';
import { checkboxInputStyles } from './styles.js';
import { jsx } from '@emotion/react';
import vars from '../../../styles/custom-properties.js';

var Label = _styled("label", "production" === "production" ? {
  target: "e2jma4r0"
} : {
  target: "e2jma4r0",
  label: "Label"
})("font-family:inherit;font-size:", vars.fontSize14, ";line-height:16px;color:", function (props) {
  return props.disabled ? vars.fontColorForInputWhenDisabled : vars.fontColorForInput;
}, ";cursor:", function (props) {
  return props.disabled ? 'not-allowed' : 'pointer';
}, ";" + ("production" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var CheckboxInput = function CheckboxInput(_ref) {
  var id = _ref.id,
      isChecked = _ref.isChecked,
      isDisabled = _ref.isDisabled,
      isIndeterminate = _ref.isIndeterminate,
      label = _ref.label,
      name = _ref.name,
      onClick = _ref.onClick,
      value = _ref.value;
  var _useState = useState(isChecked && !isIndeterminate || false),
      _useState2 = _slicedToArray(_useState, 2),
      checked = _useState2[0],
      setChecked = _useState2[1];
  var hiddenInput = useRef(null);
  useEffect(function () {
    if (!isIndeterminate) {
      setChecked(isChecked !== null && isChecked !== void 0 ? isChecked : false);
    }
  }, [isChecked, isIndeterminate]);
  var clickHiddenInput = function clickHiddenInput(event) {
    event.preventDefault();
    if (isDisabled) return;
    if (onClick) {
      onClick(event);
    }
    if (!isIndeterminate) {
      setChecked(!checked);
    }
  };
  return jsx("span", null, jsx("span", {
    "aria-checked": checked,
    css: checkboxInputStyles,
    "data-testid": "checkbox-input",
    onClick: function onClick() {
      var _hiddenInput$current;
      hiddenInput === null || hiddenInput === void 0 ? void 0 : (_hiddenInput$current = hiddenInput.current) === null || _hiddenInput$current === void 0 ? void 0 : _hiddenInput$current.click();
    },
    onKeyPress: function onKeyPress(event) {
      if (event.charCode === 32 && !isDisabled) {
        var _hiddenInput$current2;
        hiddenInput === null || hiddenInput === void 0 ? void 0 : (_hiddenInput$current2 = hiddenInput.current) === null || _hiddenInput$current2 === void 0 ? void 0 : _hiddenInput$current2.click();
      }
    },
    role: "checkbox",
    tabIndex: -1
  }, jsx("input", {
    ref: hiddenInput,
    "data-testid": "hidden-input",
    id: id,
    name: name,
    onClick: clickHiddenInput,
    type: "hidden",
    value: value
  }), jsx(Checkbox, {
    isChecked: checked,
    isDisabled: isDisabled,
    isIndeterminate: isIndeterminate
  }), label && label.length && jsx(Label, {
    disabled: isDisabled,
    htmlFor: id
  }, label)));
};
CheckboxInput.displayName = 'CheckboxInput';
CheckboxInput.defaultProps = {
  isChecked: false,
  isDisabled: false,
  isIndeterminate: false
};

export { CheckboxInput };
//# sourceMappingURL=checkbox-input.js.map
